var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inverted_expandable"},[_c('div',{class:{
      'content': true,
      'active--expanded': _vm.expanded
    },style:(`bottom: ${_vm.headerHeight}; height: ${_vm.expanded ? _vm.contentHeight : '0px'}`)},[_vm._t("content",function(){return [_vm._v(" Content ")]})],2),_c('div',{staticClass:"header",on:{"click":_vm.toggleExpanded}},[_vm._t("header",function(){return [_vm._v(" Header ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }